import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import useSWR from 'swr';

import { fetcher } from '@utils/fetchers';

import StickyCounter from '@common/components/StickyCounter';
import { shopEventUserCount } from '@common/endpoints';
import { User as UserIcon } from '@common/components/Icons';

import { UserCounterSpan } from './UserCounter.styled';

const formatUserCount = n =>
  n != null ? Number(n).toLocaleString('de-DE').replace(/\./g, "'") : '';

const UserCounter = ({ isCounterVisible, hideCounter }) => {
  const { t } = useTranslation();
  const {
    data: { userCount },
  } = useSWR(shopEventUserCount, fetcher, { refreshInterval: 20000 });

  if (userCount === null) {
    return null;
  }

  return (
    <StickyCounter
      isCounterVisible={isCounterVisible}
      hideCounter={hideCounter}
      Icon={UserIcon}
      data-testid="stickyCounterWrapper"
    >
      <UserCounterSpan>{formatUserCount(userCount)}</UserCounterSpan>
      {t('shop.info.participants.text', 'nehmen an den Chicorée Moments teil', {
        amount_participants: '',
      })}
    </StickyCounter>
  );
};

UserCounter.propTypes = {
  isCounterVisible: PropTypes.bool.isRequired,
  hideCounter: PropTypes.func.isRequired,
};

export default UserCounter;
